import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { LanguageSelectorComponent } from '@com-delta-idp/mnx-sitewide-shared-core-ui';
import { FlyoutLangSelectorFacade } from '../../data-access/facades/flyout/flyout-lang-selector/flyout-lang-selector.facade';
import { LangSelectorFacade } from '../../data-access/facades/lang-selector/langselector.facade';
import { AnalyticsDataPopulateService } from '../../data-access/services/utils/analytics/analytics-data-populate/analytics-data-populate.service';

@Component({
  selector: 'idp-lang-selector-wrapper',
  standalone: true,
  imports: [CommonModule, LanguageSelectorComponent],
  templateUrl: './lang-selector-wrapper.component.html',
  styleUrls: ['./lang-selector-wrapper.component.scss']
})
export class LangSelectorWrapperComponent implements OnInit {
  analyticsService = inject(AnalyticsDataPopulateService);

  constructor(
    public facade: LangSelectorFacade,
    public selectorFacade: FlyoutLangSelectorFacade
  ) {}

  ngOnInit(): void {
    this.facade.init();
  }

  onLanguageSelectionAnalytics(element: HTMLElement): void {
    this.analyticsService.populateAnalyticsData(
      element,
      undefined,
      undefined,
      true
    );
  }

  onAnalyticsClick(event: Event): void {
    this.analyticsService.populateAnalyticsData(
      event.currentTarget as HTMLElement,
      event,
      undefined,
      true
    );
  }
}
